import { invoke } from '@tauri-apps/api/core';

interface AppFetchResponse {
  status: number;
  headers: Record<string, string>;
  body: string;
}

/**
 * Drop-in `fetch` for the Tauri app that routes the request through Rust
 * (`app_fetch` command) and the shared cookie-jar'd client. This bypasses the
 * WKWebView's CORS + third-party-cookie restrictions: the session cookie is
 * sent, and any Set-Cookie (session, CloudFront signed cookies) is captured in
 * Rust for later resource proxying.
 *
 * Text-body only — intended for the GraphQL API (JSON/jsonpack). Binary
 * resources go through the `offlineres://` scheme handler instead.
 */
export async function tauriFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url =
    typeof input === 'string' ? input : input instanceof URL ? input.toString() : (input as Request).url;
  const method = (init?.method ?? 'GET').toUpperCase();

  const headers: Record<string, string> = {};
  if (init?.headers) {
    new Headers(init.headers).forEach((value, key) => {
      headers[key] = value;
    });
  }

  let body: string | undefined;
  if (init?.body != null) {
    body = typeof init.body === 'string' ? init.body : String(init.body);
  }

  const res = await invoke<AppFetchResponse>('app_fetch', { req: { url, method, headers, body } });
  return new Response(res.body, { status: res.status, headers: res.headers });
}
